// import React, { useContext, useEffect, useState } from "react";
// import Card from "@mui/material/Card";
// import Menu from "@mui/material/Menu";
// import MenuItem from "@mui/material/MenuItem";
// import MDBox from "components/MDBox";
// import MDTypography from "components/MDTypography";
// import DataTable from "examples/Tables/DataTable";
// import MDModal from "components/MDModal";
// import AddMemberForm from "layouts/Page/member/Form/member";
// import { ModalContext } from "context/ModalContext";
// import DefaultCell from "examples/Tables/DataTable/components/DefaultCell";
// import PropTypes from "prop-types";
// import { getMember } from "Apis/member";
// import { LoginFormContext } from "context/LoginFormContext";
// import { memberList } from "Apis/member";
// import { Avatar } from "@mui/material";
// import MDActionButton from "components/MDActionButton";
// import Imagepreview from "components/MDImagePreview";
// import colors from "assets/theme/base/colors";
// import moment from "moment";
// import MDBoxRoot from "components/MDBox/MDBoxRoot";
// import SubmitButton from "components/SubmitButton";
// import { Link, useNavigate } from "react-router-dom";
// import styled from "@emotion/styled";
// import { MdArrowForward } from "react-icons/md";
// import { MemberContext } from "context/MemberContext";
// import { CommonContext } from "context/CommonContext";
// const { info } = colors;

// const ViewLink = styled(Link)`
//   color: ${info.main};
//   text-decoration: none;
//   &:hover {
//     text-decoration: underline !important;
//   }
// `;
// function Projects() {
//   const [menu, setMenu] = useState(null);
//   const { formIsEdit, open, setFormIsEdit, setOpen } = useContext(ModalContext);
//   const { parentDataListing, educationListing, occupationListing } = useContext(MemberContext);
//   const { districtList, talukaList, villageList } = useContext(CommonContext);
//   const { setMemberEditData } = useContext(LoginFormContext);
//   const openMenu = ({ currentTarget }) => setMenu(currentTarget);
//   const closeMenu = () => setMenu(null);
//   const [member, setMember] = useState([]);
//   const { sideNav, info } = colors;
//   const navigate = useNavigate();

//   const renderMenu = (
//     <Menu
//       id="simple-menu"
//       anchorEl={menu}
//       anchorOrigin={{
//         vertical: "top",
//         horizontal: "left",
//       }}
//       transformOrigin={{
//         vertical: "top",
//         horizontal: "right",
//       }}
//       open={Boolean(menu)}
//       onClose={closeMenu}
//     >
//       <MenuItem onClick={closeMenu}>Action</MenuItem>
//       <MenuItem onClick={closeMenu}>Another action</MenuItem>
//       <MenuItem onClick={closeMenu}>Something else</MenuItem>
//     </Menu>
//   );

//   const editMember = async (id) => {
//     await parentDataListing();
//     await districtList(), await talukaList(), await villageList();
//     await educationListing();
//     await occupationListing();
//     let response = await getMember(id);
//     if (response?.status === 200) {
//       setMemberEditData(response?.data?.data);
//       setOpen(true);
//       setFormIsEdit(true);
//     }
//   };

//   const memberListing = async () => {
//     let response = await memberList();
//     if (response?.status === 200) {
//       setMember(response?.data?.data?.rows);
//     }
//   };
//   useEffect(() => {
//     memberListing();
//   }, [open]);

//   const [selectedImage, setSelectedImage] = useState(null);
//   const [isImageModalOpen, setIsImageModalOpen] = useState(false);

//   const handleImageClick = (imageUrl) => {
//     setSelectedImage(imageUrl);
//     setIsImageModalOpen(true);
//   };

//   let data = {
//     isFilter: false,
//     columns: [
//       {
//         Header: "Name",
//         accessor: "first_name",
//         minWidth: "85px",
//         sort: false,
//         Cell: ({ value, row }) => {
//           const imageUrl = row?.original?.member_images[0]?.image;

//           const [imgError, setImgError] = React.useState(false);

//           return (
//             <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//               {imageUrl && !imgError ? (
//                 <img
//                   src={imageUrl}
//                   alt="image"
//                   onError={() => setImgError(true)}
//                   onClick={() => handleImageClick(imageUrl)}
//                   style={{
//                     height: "50px",
//                     width: "50px",
//                     borderRadius: "100%",
//                     objectFit: "cover",
//                     border: "1px solid #7b809a",
//                     cursor: "pointer",
//                   }}
//                 />
//               ) : (
//                 <Avatar
//                   sx={{
//                     height: "50px",
//                     width: "50px",
//                     "&:hover": {
//                       background: "#1a73e8 !important",
//                     },
//                   }}
//                 />
//               )}
//               <DefaultCell value={value || "-"} />
//             </div>
//           );
//         },
//       },
//       {
//         Header: "Middle Name",
//         accessor: "middle_name",
//         minWidth: "85px",
//         Cell: ({ value }) => <DefaultCell value={value ? value : "-"} />,
//       },
//       {
//         Header: "Surname",
//         accessor: "surname",
//         minWidth: "85px",
//         Cell: ({ value }) => <DefaultCell value={value ? value : "-"} />,
//       },
//       {
//         Header: "Member Number",
//         accessor: "member_number",
//         minWidth: "85px",
//         Cell: ({ value }) => <DefaultCell value={value ? value : "-"} />,
//       },
//       {
//         Header: "Gender",
//         accessor: "gender",
//         minWidth: "85px",
//         sort: false,
//         Cell: ({ value }) => <DefaultCell value={value ? value : "-"} />,
//       },
//       {
//         Header: "Email",
//         accessor: "email",
//         minWidth: "85px",
//         sort: false,
//         Cell: ({ value }) => <DefaultCell value={value ? value : "-"} />,
//       },
//       {
//         Header: "Created date",
//         accessor: "createdAt",
//         sort: true,
//         Cell: ({ value }) => (
//           <DefaultCell value={value ? moment(value).format("DD-MM-YYYY hh:mm A") : "-"} />
//         ),
//       },
//       {
//         Header: "Action",
//         accessor: "action",
//         width: "12%",
//         Cell: ({ value, row }) => (
//           <MDBox sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
//             <MDActionButton type="edit" onClick={() => editMember(row.original.id)} />
//           </MDBox>
//         ),
//       },
//     ],
//     rows: member,
//   };

//   const navigateToMember = () => {
//     navigate("/members");
//   };

//   return (
//     <Card>
//       <MDBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
//         <MDBox>
//           <MDTypography variant="h5" color={sideNav.textColor} gutterBottom>
//             Members
//           </MDTypography>
//           <MDBox display="flex" alignItems="center" lineHeight={0}>
//             {member?.length > 0 && (
//               <MDBox fontSize="16px" mt={1} fontWeight="regular" color={info.main}>
//                 The most recent <strong style={{ color: `${sideNav.hoverTextColor}` }}>10</strong>{" "}
//                 members to join us.
//               </MDBox>
//             )}
//           </MDBox>
//         </MDBox>
//         <MDTypography
//           variant="h6"
//           fontWeight="medium"
//           sx={{
//             fontSize: "14px",
//             lineHeight: "16px",
//             paddingRight: "10px",
//             position: "absolute",
//             top: "10px",
//             right: 0,
//           }}
//         >
//           <ViewLink to="/members" style={{ display: "flex", alignItems: "center" }}>
//             View all members
//             <MdArrowForward style={{ marginLeft: "5px" }} />
//           </ViewLink>
//         </MDTypography>
//       </MDBox>
//       {open && (
//         <MDModal hasButton={false} modalHead={`${formIsEdit ? "Edit" : "Add"} Member`}>
//           <AddMemberForm />
//         </MDModal>
//       )}

//       <MDBox>
//         <DataTable
//           table={data}
//           showTotalEntries={false}
//           isSorted={false}
//           noEndBorder
//           showEntriesPerPage={false}
//         />
//         {selectedImage && (
//           <Imagepreview
//             open={isImageModalOpen}
//             onClose={() => setIsImageModalOpen(false)}
//             imageUrl={selectedImage}
//           />
//         )}
//       </MDBox>
//     </Card>
//   );
// }

// Projects.propTypes = {
//   value: PropTypes.string,
//   row: PropTypes.string,
//   memberListing: PropTypes.func,
//   open: PropTypes.bool.isRequired,
//   onClose: PropTypes.func.isRequired,
//   imageUrl: PropTypes.string.isRequired,
// };

// export default Projects;

import React, { useContext, useEffect, useState } from "react";
import Card from "@mui/material/Card";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
import { getBusinessListApi } from "Apis/businessApi";
import { getMatrimonialListApi } from "Apis/matrimonialApi";
import { Avatar } from "@mui/material";
import DefaultCell from "examples/Tables/DataTable/components/DefaultCell";
import colors from "assets/theme/base/colors";
import business from "../../../../assets/images/placeholder.jpg";
import MDActionButton from "components/MDActionButton";
import VerifiedIcon from "@mui/icons-material/Verified";
import { verifyMember } from "Apis/member";
import { verifyBusinessDataApi } from "Apis/businessApi";
import { verifyMatrimonialDataApi } from "Apis/matrimonialApi";
import VerifiedStatus from "components/MDVerifiedStatus";
import Swal from "sweetalert2";
import Imagepreview from "components/MDImagePreview";
import { LoginFormContext } from "context/LoginFormContext";
import { unverifiedMemberList } from "Apis/member";
import SubmitButton from "components/SubmitButton";

function MembersPage() {
  const { modules } = useContext(LoginFormContext);
  const [activeTab, setActiveTab] = useState("");
  const [member, setMember] = useState([]);
  const [businessList, setBusinessList] = useState([]);
  const [matrimonial, setMatrimonial] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const { imageBorder } = colors;

  const [memberFilter, setMemberFilter] = useState({
    currentPage: 1,
    itemsPerPage: 5,
    filters: { is_verified: "0" },
  });

  const [businessFilter, setBusinessFilter] = useState({
    currentPage: 1,
    itemsPerPage: 5,
    filters: { is_verified: "0" },
  });

  const [matrimonialFilter, setMatrimonialFilter] = useState({
    currentPage: 1,
    itemsPerPage: 5,
    filters: { is_verified: "0" },
  });

  const fetchData = async () => {
    if (activeTab === "members") {
      let response = await unverifiedMemberList(memberFilter);
      if (response?.status === 200) {
        setMember(response?.data?.data?.rows);
        setRowCount(response?.data?.data?.count);
      }
    } else if (activeTab === "businesses") {
      let response = await getBusinessListApi(businessFilter);
      if (response?.status === 200) {
        setBusinessList(response?.data?.data?.rows);
        setRowCount(response?.data?.data?.count);
      }
    } else if (activeTab === "matrimonials") {
      let response = await getMatrimonialListApi(matrimonialFilter);
      if (response?.status === 200) {
        setMatrimonial(response?.data?.data?.rows);
        setRowCount(response?.data?.data?.count);
      }
    }
  };
  useEffect(() => {
    fetchData();
  }, [activeTab, memberFilter, businessFilter, matrimonialFilter]);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const [selectedImage, setSelectedImage] = useState(null);
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
    setIsImageModalOpen(true);
  };

  const handleVerify = async (row, type) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You really want to verify this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, verify it!",
    });

    if (result.isConfirmed) {
      let response;
      if (type === "member") {
        response = await verifyMember(row.id);
      } else if (type === "business") {
        response = await verifyBusinessDataApi(row.id);
      } else if (type === "matrimonial") {
        response = await verifyMatrimonialDataApi(row.id);
      }

      if (response?.status === 200) {
        fetchData();
        Swal.fire("Verified!", response.data.message, "success");
      } else {
        Swal.fire("Error!", response?.data?.message || "Something went wrong", "error");
      }
    }
  };

  useEffect(() => {
    if (!activeTab && modules?.length > 0) {
      const allowedModules = modules.filter((module) => module.permissions?.read_access);
      if (allowedModules.length > 0) {
        setTimeout(() => {
          if (allowedModules.some((module) => module?.name === "Member")) {
            setActiveTab("members");
          } else if (allowedModules.some((module) => module?.name === "Business")) {
            setActiveTab("businesses");
          } else if (allowedModules.some((module) => module?.name === "Matrimonial")) {
            setActiveTab("matrimonials");
          }
        }, 100);
      }
    }
  }, [modules, activeTab]);

  const memberColumns = [
    {
      Header: "Member Number",
      accessor: "member_number",
      minWidth: "85px",
      Cell: ({ value }) => <DefaultCell value={value ? value : "-"} />,
    },
    {
      Header: "Full Name",
      accessor: "first_name",
      minWidth: "85px",
      sort: false,
      Cell: ({ value, row }) => {
        const imageUrl = row?.original?.member_images[0]?.image;

        const [imgError, setImgError] = React.useState(false);
        const isVerified = row?.original?.is_verified === 1;

        return (
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            {imageUrl && !imgError ? (
              <div style={{ position: "relative", display: "inline-block" }}>
                <img
                  src={imageUrl}
                  alt="image"
                  onError={() => setImgError(true)}
                  onClick={() => handleImageClick(imageUrl)}
                  style={{
                    height: "50px",
                    width: "50px",
                    borderRadius: "100%",
                    objectFit: "cover",
                    border: "1px solid #7b809a",
                    cursor: "pointer",
                  }}
                />
                {isVerified && (
                  <VerifiedIcon
                    sx={{
                      position: "absolute",
                      bottom: "5px",
                      right: 0,
                      backgroundColor: "#fff",
                      borderRadius: "50%",
                      width: "16px",
                      height: "16px",
                      color: `${imageBorder.verifiedIconColor}`,
                    }}
                  />
                )}
              </div>
            ) : (
              <div style={{ position: "relative", display: "inline-block" }}>
                <Avatar
                  sx={{
                    height: "50px",
                    width: "50px",
                    "&:hover": {
                      background: "#1a73e8 !important",
                    },
                  }}
                />
                {isVerified && (
                  <VerifiedIcon
                    sx={{
                      position: "absolute",
                      bottom: 0,
                      right: 0,
                      backgroundColor: "#fff",
                      borderRadius: "50%",
                      width: "16px",
                      height: "16px",
                      color: `${imageBorder.verifiedIconColor}`,
                    }}
                  />
                )}
              </div>
            )}
            <DefaultCell
              value={
                value + " " + row?.original?.middle_name + " " + row?.original?.surname + " " || "-"
              }
            />
          </div>
        );
      },
    },

    {
      Header: "Gender",
      accessor: "gender",
      minWidth: "85px",
      sort: false,
      Cell: ({ value }) => <DefaultCell value={value ? value : "-"} />,
    },
    {
      Header: "Email",
      accessor: "email",
      minWidth: "85px",
      sort: false,
      Cell: ({ value }) => <DefaultCell value={value ? value : "-"} />,
    },
    {
      Header: "Head",
      accessor: "is_head_person",
      minWidth: "85px",
      sort: false,
      Cell: ({ value }) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <SubmitButton
            background={value === 1 ? "#a68181" : `#7f868f`}
            hoverBackground={value === 1 ? `#a68181` : `#7f868f`}
            color="#fff"
            btnText={value === 1 ? "Head" : "Not Head"}
            type="button"
          >
            {value === 1 ? "Head" : "Not Head"}
          </SubmitButton>
        </div>
      ),
    },
    {
      Header: "Verification Status",
      accessor: "is_verified",
      minWidth: "85px",
      sort: false,
      Cell: ({ value }) => <VerifiedStatus data={value} />,
    },
    {
      Header: "Action",
      accessor: "action",
      width: "12%",
      Cell: ({ value, row }) => (
        <MDBox sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
          {row.original.is_verified === 0 && (
            <MDActionButton type="verify" onClick={() => handleVerify(row.original, "member")} />
          )}
        </MDBox>
      ),
    },
  ];

  const businessColumns = [
    {
      Header: "name",
      accessor: "name",
      minWidth: "85px",
      sort: false,
      Cell: ({ value, row }) => {
        const imageUrl = row?.original?.business_images[0]?.image;

        const [imgError, setImgError] = React.useState(false);
        const isVerified = row?.original?.is_verified === 1;

        return (
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            {imageUrl && !imgError ? (
              <div style={{ position: "relative", display: "inline-block" }}>
                <img
                  src={imageUrl}
                  alt="image"
                  onError={() => setImgError(true)}
                  onClick={() => handleImageClick(imageUrl)}
                  style={{
                    height: "50px",
                    width: "50px",
                    borderRadius: "100%",
                    objectFit: "cover",
                    border: `1px solid ${imageBorder.borderColor}`,
                    cursor: "pointer",
                  }}
                />
                {isVerified && (
                  <VerifiedIcon
                    sx={{
                      position: "absolute",
                      bottom: "5px",
                      right: 0,
                      backgroundColor: "#fff",
                      borderRadius: "50%",
                      width: "16px",
                      height: "16px",
                      color: `${imageBorder.verifiedIconColor}`,
                    }}
                  />
                )}
              </div>
            ) : (
              <div style={{ position: "relative", display: "inline-block" }}>
                <img
                  src={business}
                  alt="image"
                  style={{
                    height: "50px",
                    width: "50px",
                    borderRadius: "100%",
                    objectFit: "fill",
                    border: `1px solid ${imageBorder.borderColor}`,
                  }}
                />
                {isVerified && (
                  <VerifiedIcon
                    sx={{
                      position: "absolute",
                      bottom: 0,
                      right: 0,
                      backgroundColor: "#fff",
                      borderRadius: "50%",
                      width: "16px",
                      height: "16px",
                      color: `${imageBorder.verifiedIconColor}`,
                    }}
                  />
                )}
              </div>
            )}
            <DefaultCell value={value || "-"} />
          </div>
        );
      },
    },
    {
      Header: "owner name",
      accessor: "owner_name",
      minWidth: "85px",
      sort: false,
      Cell: ({ value }) => <DefaultCell value={value || "-"} />,
    },
    {
      Header: "phone number",
      accessor: "phone_number",
      minWidth: "85px",
      sort: false,
      Cell: ({ value }) => <DefaultCell value={value || "-"} />,
    },
    {
      Header: "email",
      accessor: "email",
      minWidth: "85px",
      sort: false,
      Cell: ({ value }) => <DefaultCell value={value || "-"} />,
    },
    {
      Header: "Verification Status",
      accessor: "is_verified",
      minWidth: "85px",
      sort: false,
      Cell: ({ value }) => <VerifiedStatus data={value} />,
    },
    {
      Header: "Action",
      accessor: "action",
      width: "12%",
      Cell: ({ value, row }) => (
        <MDBox sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
          {row.original.is_verified === 0 && (
            <MDActionButton type="verify" onClick={() => handleVerify(row.original, "business")} />
          )}
        </MDBox>
      ),
    },
  ];

  const matrimonialColumns = [
    {
      Header: "Full Name",
      accessor: "full_name",
      minWidth: "85px",
      sort: false,
      Cell: ({ value, row }) => {
        const findImage = row?.original?.matrimonial_documents.find(
          (data) => data?.type === "Image"
        );

        const [imgError, setImgError] = React.useState(false);
        const isVerified = row?.original?.is_verified === 1;

        return (
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            {findImage && !imgError ? (
              <div style={{ position: "relative", display: "inline-block" }}>
                {row?.original?.matrimonial_documents.map((data, index) => {
                  if (data?.type === "Image") {
                    return (
                      <img
                        key={index}
                        src={data?.image}
                        alt="image"
                        onError={() => setImgError(true)}
                        onClick={() => handleImageClick(data?.image)}
                        style={{
                          height: "50px",
                          width: "50px",
                          borderRadius: "100%",
                          objectFit: "fill",
                          border: `1px solid ${imageBorder.borderColor}`,
                          cursor: "pointer",
                        }}
                      />
                    );
                  }
                  return null;
                })}
                {isVerified && (
                  <VerifiedIcon
                    sx={{
                      position: "absolute",
                      bottom: 0,
                      right: 0,
                      backgroundColor: "#fff",
                      borderRadius: "50%",
                      width: "16px",
                      height: "16px",
                      color: `${imageBorder.verifiedIconColor}`,
                    }}
                  />
                )}
              </div>
            ) : (
              <div style={{ position: "relative", display: "inline-block" }}>
                <Avatar
                  sx={{
                    height: "50px",
                    width: "50px",
                    "&:hover": {
                      background: `${imageBorder.backgroundColor} !important`,
                    },
                  }}
                />
                {isVerified && (
                  <VerifiedIcon
                    sx={{
                      position: "absolute",
                      bottom: 0,
                      right: 0,
                      backgroundColor: "#fff",
                      borderRadius: "50%",
                      width: "18px",
                      height: "18px",
                      color: `${imageBorder.verifiedIconColor}`,
                    }}
                  />
                )}
              </div>
            )}
            <DefaultCell value={value || "-"} />
          </div>
        );
      },
    },
    {
      Header: "Marital Status",
      accessor: "marital_status",
      minWidth: "85px",
      sort: false,
      Cell: ({ value }) => <DefaultCell value={value || "-"} />,
    },
    {
      Header: "Gender",
      accessor: "gender",
      minWidth: "85px",
      sort: false,
      Cell: ({ value }) => <DefaultCell value={value || "-"} />,
    },
    {
      Header: "Verification Status",
      accessor: "is_verified",
      minWidth: "85px",
      sort: false,
      Cell: ({ value }) => <VerifiedStatus data={value} />,
    },
    {
      Header: "Action",
      accessor: "action",
      width: "12%",
      Cell: ({ row }) => {
        return (
          <MDBox sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
            {row.original.is_verified === 0 && (
              <MDActionButton
                type="verify"
                onClick={() => handleVerify(row.original, "matrimonial")}
              />
            )}
          </MDBox>
        );
      },
    },
  ];

  const data = {
    isFilter: false,
    columns:
      activeTab === "members"
        ? memberColumns
        : activeTab === "businesses"
          ? businessColumns
          : activeTab === "matrimonials"
            ? matrimonialColumns
            : null,
    rows:
      activeTab === "members"
        ? member
        : activeTab === "businesses"
          ? businessList
          : activeTab === "matrimonials"
            ? matrimonial
            : null,
  };

  return (
    <Card>
      <MDBox display="flex" flexDirection="column" p={3}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          textColor="primary"
          indicatorColor="primary"
        >
          {modules.map((module) => {
            if (module?.name === "Member" && module.permissions?.read_access) {
              return <Tab value="members" label="Members" />;
            }
            if (module?.name === "Business" && module.permissions?.read_access) {
              return <Tab value="businesses" label="Businesses" />;
            }
            if (module?.name === "Matrimonial" && module.permissions?.read_access) {
              return <Tab value="matrimonials" label="Matrimonials" />;
            }
            return null;
          })}
        </Tabs>
        {data?.columns ? (
          <DataTable
            table={data}
            rowCount={rowCount}
            entriesPerPage={true}
            showTotalEntries={false}
            showRowPaginationOptions={false}
            defaultFilter={
              activeTab === "members"
                ? memberFilter
                : activeTab === "businesses"
                  ? businessFilter
                  : activeTab === "matrimonials"
                    ? matrimonialFilter
                    : []
            }
            setDefaultFilter={
              activeTab === "members"
                ? setMemberFilter
                : activeTab === "businesses"
                  ? setBusinessFilter
                  : activeTab === "matrimonials"
                    ? setMatrimonialFilter
                    : []
            }
            noEndBorder
          />
        ) : (
          ""
        )}
        {selectedImage && (
          <Imagepreview
            open={isImageModalOpen}
            onClose={() => setIsImageModalOpen(false)}
            imageUrl={selectedImage}
          />
        )}
      </MDBox>
    </Card>
  );
}

export default MembersPage;
